import React, { useEffect } from "react";
import useTitle from "../Hooks/useTitle";
import { useTranslation } from "react-i18next";

const NotFoundPage = () => {
  useTitle("Not Found | Netileti");
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = "/login";
    }, 5000);

    return () => clearTimeout(timer);
  }, []);
  const { t } = useTranslation();
  return (
    <div
      className="content"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontSize: "24px",
      }}
    >
      <h1>404 - {t("Not Found")}</h1>
      <p>{t("redirected")}</p>
    </div>
  );
};

export default NotFoundPage;
